import { useQuery } from '@tanstack/react-query';

import { BuildingModel } from '@/api/models/building';
import { TenantModel, TenantModelWithContacts } from '@/api/models/tenant';
import { UnitModel } from '@/api/models/unit';
import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_GetOne_Tenant = TenantModelWithContacts & {
  unit: UnitModel & {
    building: BuildingModel;
  };
};

const METHOD = 'GET';
const ENDPOINT = 'tenant/:id';
export const QUERY_KEY = (id: TenantModel['id']) => getQueryKey(METHOD, ENDPOINT, { id });

export const useGetOneTenant = (id: TenantModel['id'], enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(id),
    queryFn: async () => {
      const data = await handleApiCall<ApiResponse_GetOne_Tenant>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {
          id: id.toString(),
        })
      );

      return data;
    },
  });
};
